import { AdvanceModalState, OpenModalState } from ".";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: AdvanceModalState = {
  type: "",
  data: null,
  open: false,
  width: "50%",
  loading: false,
};

export const advanceModalSlice = createSlice({
  name: "advanceModal",
  initialState,
  reducers: {
    openAdvanceModal(state, action: PayloadAction<OpenModalState>) {
      const { type, data, width } = action.payload;
      state.data = data;
      state.type = type;
      state.open = true;
      state.width = width;
    },
    closeAdvanceModal(state) {
      state.type = "";
      state.data = null;
      state.open = false;
      state.width = "50%";
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});

const advanceModalReducer = advanceModalSlice.reducer;

export const advanceModalActions = advanceModalSlice.actions;
export default advanceModalReducer;
